import { AuthService } from '@services';
import { Observable } from 'rxjs';

export function appInitFactory(auth: AuthService): () => Observable<void> {
  return () => auth.init();
}
